package eu.codlab.compose.theme

import androidx.compose.ui.graphics.Color

data class ColorBottomNavigations(
    val background: Color = Color.Transparent,
    val unselected: Color = Color.Blue,
    val selected: Color = Color.Cyan
)
